/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Info_Code_PendingInputs */



/**
* | output |
* | --- |
* | "assigning…" |
*
* @param {Tournament_Info_Code_PendingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_info_code_pending = /** @type {((inputs?: Tournament_Info_Code_PendingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Info_Code_PendingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("attribution…")
	if (locale === "es") return /** @type {LocalizedString} */ ("asignando…")
	if (locale === "pt") return /** @type {LocalizedString} */ ("atribuindo…")
	if (locale === "it") return /** @type {LocalizedString} */ ("assegnazione…")
	return /** @type {LocalizedString} */ ("assigning…")
});